type ProductResourcesCardContainerProps = {
	children: React.ReactNode
}

export default function ProductResourcesCardContainer({
	children,
}: ProductResourcesCardContainerProps) {
	return (
		<div className="flex flex-col px-4 py-2 rounded-2xl bg-white border border-gray-100">
			{children}
		</div>
	)
}
